module.exports = __webpack_public_path__ + "static/media/anticipating_ev_vehicles_era.bb2e71b7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anticipating_ev_vehicles_era.webp
// module id = 318
// module chunks = 0